<template>
  <div class="modal-body-user-info">
    <div class="description">
      Add a new client by entering the information below.
    </div>
    <div class="email">
      <div class="text">Client name:</div>
      <div>
        <input class="input" type="text" placeholder="Client name" v-model="clientInfo.clientName">
      </div>
    </div>
    <div class="name row">
      <div class="first-name">
        <div class="text">Client contact first name:</div>
        <div>
          <input class="input" type="text" placeholder="First Name" v-model="clientInfo.firstName">
        </div>
      </div>
      <div class="last-name">
        <div class="text">Client contact last name:</div>
        <div >
          <input class="input" type="text" placeholder="Last Name" v-model="clientInfo.lastName">
        </div>
      </div>
    </div>
    <div class="email">
      <div class="text">Client contact's email address:</div>
      <div>
        <input class="input" type="text" placeholder="E.g. hannah_welch@gmail.com" v-model="clientInfo.email">
      </div>
      <div v-if="!isEmail()" class="errorBackground">
        <span class="errorDetail">Invalid email format.</span>
      </div>
    </div>
  </div>
</template>

<script>
// import {mapGetters} from 'vuex';
import consts from '../../_consts';

export default {
  name: 'add-client-body-modal',
  data () {
    return {};
  },
  props: {
    clientInfo: {
      type: Object,
      default: {}
    }
  },
  methods: {
    isEmail () {
      if (this.clientInfo.email === '') {
        this.$emit('disableBtnRight', true);
        return true;
      }
      let isValidEmail = consts.validateEmail(this.clientInfo.email);
      this.$emit('disableBtnRight', !isValidEmail);
      return isValidEmail;
    }
  },
  watch: {
    clientInfo: {
      handler: function () {
        if (this.clientInfo.email) {
          this.isEmail(this.clientInfo.email);
        }
      },
      deep: true
    }
  },
  created () {
    this.$emit('disableBtnRight', true);
  }
}
</script>

<style lang="less">
  .modal-body-user-info{
    color: #231F20;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    margin-bottom: 60px;
    .description{
      line-height: 14px;
    }
    .input{
      height: 38px;
      border: 1px solid #d9d9d9;
      border-radius: 3px;
      padding-left: 12px;
    }
    .name{
      margin: 30px 0 0 0;
      .last-name{
        margin-left: 40px;
        .text{}
        .input{
          width: 275px;
        }
      }
      .first-name{
        .text{}
        .input{
          width: 275px;
        }
      }
    }
    .email{
      margin: 30px 0 0 0;
      .text{}
      .input{
        width: 590px;
      }
    }
    .errorBackground {
      background-color: #FEE2E2;
      width: 588px;
      margin-top: 1px;
    }
    .errorDetail {
      height: 17px;
      width: 108px;
      color: #803939;
      font-family: "Open Sans",serif;
      font-size: 12px;
      line-height: 17px;
      text-align: right;
      margin-left: 5px;
    }
  }
</style>




// WEBPACK FOOTER //
// AddClientModal.vue?dcf430ca